import { createFileRoute } from '@tanstack/react-router';
import { OrdersView } from '../../orders/orders-view.js';

export const Route = createFileRoute('/_station/orders')({
  component: OrdersView,
});
